<div class="cdk-overlay-container">
  <div class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"></div>
  <div class="cdk-global-overlay-wrapper" style="justify-content: center; align-items: center">
    <div class="cdk-overlay-pane">
      <mat-spinner color="warn" [mode]="mode" [value]="progress"></mat-spinner>
    </div>
  </div>
</div>
